export default __webpack_public_path__ + "static/media/laundry2-after-768w.2c2052ad.avif";